'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('./paths');

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, ev_a_id, ev_b_id, data) {
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      ev_a_id: ev_a_id,
      ev_b_id: ev_b_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisEventsPrefix)(feis_id) + '/' + ev_a_id + '/merge/' + ev_b_id,
        method: 'POST',
        data: data
      },
      types: ['MERGE_EVENT_START', 'MERGE_EVENT', 'MERGE_EVENT_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/mergeEvents.js
// module id = 644
// module chunks = 0